module.exports = __webpack_public_path__ + "img/slide.daf16e6b.svg";